import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { applyDocumentLanguage, getLocaleFromPath, getLocalizedPath, LANGUAGE_OPTIONS } from "@/lib/locale";

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const language = getLocaleFromPath(location.pathname) || "tr";
  const selected = LANGUAGE_OPTIONS.find((item) => item.code === language) || LANGUAGE_OPTIONS[0];

  useEffect(() => {
    localStorage.setItem("nolena-language", language);
    i18n.changeLanguage(language);
    applyDocumentLanguage(language);
    window.dispatchEvent(new Event("nolena-language"));
  }, [i18n, language]);

  useEffect(() => {
    const close = (event) => { if (!ref.current?.contains(event.target)) setOpen(false); };
    window.addEventListener("pointerdown", close);
    return () => window.removeEventListener("pointerdown", close);
  }, []);

  const chooseLanguage = (code) => {
    setOpen(false);
    navigate(getLocalizedPath(location.pathname, code));
  };

  return <div ref={ref} className="relative">
    <button type="button" aria-label={t("common.chooseLanguage")} aria-expanded={open} onClick={() => setOpen((current) => !current)} className="flex items-center justify-center gap-1 bg-transparent p-0 text-ink transition hover:opacity-75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40">
      <img src={`/flags/${selected.flag}.svg`} alt={selected.name} className="h-4 w-6 rounded-sm object-cover" />
      <ChevronDown className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`} />
    </button>
    {open && <div role="menu" className="absolute right-0 z-[70] mt-2 grid w-11 grid-cols-1 gap-1 rounded-xl border border-detail bg-surface py-2 shadow-xl" dir="ltr">
      {LANGUAGE_OPTIONS.map((item) => <button key={item.code} type="button" role="menuitem" title={item.name} aria-label={item.name} onClick={() => chooseLanguage(item.code)} className={`grid h-8 place-items-center bg-transparent transition hover:scale-110 hover:opacity-100 focus-visible:outline-none ${item.code === language ? "scale-110 opacity-100" : "opacity-70"}`}>
        <img src={`/flags/${item.flag}.svg`} alt="" className="h-4 w-6 rounded-sm object-cover" />
      </button>)}
    </div>}
  </div>;
};
